import PaginationComponent from './PaginationComponent';
export * from './PaginationComponent';
export default PaginationComponent;
